import React from "react";
import CartNavigation from "./CartNavigation";
import { withShoppingCartContainer  } from "../../containers/gamification2026";

const CartLayout = (props) => {
  const { children, cart } = props;
  const showNavigation = props.history.location.pathname !== "/cart/success";
  return (
    <div className="cart-layout">
      {cart && cart.items &&  (
        <h4 className="cart-layout-title">
          O meu carrinho <div className="cart-layout-title-count">({cart.items.length} prémios)</div>
        </h4>
      )}
      <section className="cart-layout-content">
        {showNavigation && <CartNavigation />}
        {children}
      </section>
    </div>
  );
};

export default withShoppingCartContainer(CartLayout);
